// components
import Label from './Label'

const OptionRadio = ({
    children,
   ...props
}) => {


    const handleChange = (answer) => {
        props.handleAnswer(answer, props.id)
    }

    return (
        <Label
            className={props.className}
            for={props.text}
            key={props.text}
        >
            <input
                className="pension-wizard-block__question__card__options__option__radio__input"
                type='radio'
                name='radio'
                id={props.text}
                value={props.text}
                onChange={(event) => handleChange(event.target.value)}
            />
            {props.text}
        </Label>
     )
}

export default OptionRadio;